export const tags = [
  "course-content",
  "panel-messages",
  "jnct-message",
  "panel-manage-course",
  "jnct-notes-panel",
] as const;
